<template>
    <div class="baseSet" v-auth="`Content.CourseVideoSeting.Save`">
        <a-form-model
                :model="form"
                :rules="modleRules"
                :label-col="labelCol"
                :wrapper-col="wrapperCol"
                labelAlign="right"
                ref="addForm"
                class="baseForm"
        >
            <a-row>
                <a-col :span="16">
                    <a-row>
                        <a-col style="height: 70px;" :span="12">
                            <a-form-model-item label="视频名称" ref="name" prop="name">
                                <a-input v-model="form.name" :maxLength="30"/>
                            </a-form-model-item>
                        </a-col>
                        <a-col style="height: 70px;" :span="12">
                            <a-form-model-item label="版本名称">
                                <a-input v-model="form.versionName" :maxLength="30"/>
                            </a-form-model-item>
                        </a-col>
                        <!-- <a-col style="height: 70px;" :span="12">
                            <a-form-model-item label="视频ID" prop="uri">
                                <a-input v-model="form.uri"/>
                            </a-form-model-item>
                        </a-col> -->
                        <a-col style="height: 70px;" :span="12">
                            <a-form-model-item label="视频类型" ref="scientificName" prop="scientificName">
                                <a-select allowClear @change="selectChange" v-model="form.scientificName" placeholder="请选择">
                                    <a-select-option v-for="item in scientificName" :value="item.name">
                                        {{item.name}}
                                    </a-select-option>
                                </a-select>
                            </a-form-model-item>
                        </a-col>
                        <a-col style="height: 70px;" :span="12">
                            <a-form-model-item label="一级能力" ref="firstAbilityId" prop="firstAbilityId">
                                <a-tree-select
                                        v-model="form.firstAbilityId"
                                        style="width: 100%"
                                        @change="firstAbilityChange"
                                        treeDefaultExpandAll
                                        :replaceFields="{title: 'name',value: 'id',key: 'id' }"
                                        :dropdown-style="{ maxHeight: '200px', overflow: 'auto' }"
                                        :selectable="false"
                                        placeholder="请选择一级能力"
                                >
                                    <a-tree-select-node
                                            :key="items.id"
                                            :value="items.id"
                                            :title="items.name"
                                            v-for="items in firstAbility"
                                            :selectable="false"
                                    >
                                        <a-tree-select-node
                                                :key="item.id"
                                                :value="item.id"
                                                :title="item.name"
                                                v-for="item in items.children"
                                        />
                                    </a-tree-select-node>
                                </a-tree-select>
                            </a-form-model-item>
                        </a-col>
                        <!-- <a-col style="height: 70px;" :span="12">
                            <a-form-model-item label="视频时长" ref="endTime" prop="endTime">
                                <a-time-picker v-model="dataEndTime" @change="changeTime" style="width:100%;">
                                    <div slot="addon" style="display: flex;">
                                        <span style="width:33%;text-align:center;">时</span>
                                        <span style="width:33%;text-align:center;">分</span>
                                        <span style="width:33%;text-align:center;">秒</span>
                                    </div>
                                </a-time-picker>
                            </a-form-model-item>
                        </a-col> -->
                        <a-col style="height: 70px;" :span="12">
                            <a-form-model-item label="适用年龄段" class="age">
                                <div class="age-cont" :data-age="age">
                                    <a-form-model-item :wrapper-col="{span: 24}" prop="minAge">
                                        <a-input-number v-model="form.minAge" style="width: 100%;"/>
                                    </a-form-model-item>
                                    <span style="margin: 0 10px 20px;">-</span>
                                    <a-form-model-item :wrapper-col="{span: 24}" prop="maxAge">
                                        <a-input-number v-model="form.maxAge" style="width: 100%;"/>
                                    </a-form-model-item>
                                </div>
                            </a-form-model-item>
                        </a-col>
                        <a-col style="height: 70px;" :span="12">
                            <a-form-model-item label="状态">
                                <a-switch default-checked :checked="form.enabled" @change="StatusChange"/>
                            </a-form-model-item>
                        </a-col>
                    </a-row>
                </a-col>
                <a-col :span="8">
                    <a-form-model-item ref="icon" prop="icon" label="icon">
                        <div>
                            <a-upload
                                    name="imgFile"
                                    list-type="picture-card"
                                    class="avatar-uploader"
                                    :show-upload-list="false"
                                    :headers="headers"
                                    :action="baseURL"
                                    @change="changeIcon"
                                    :before-upload="beforeIcon"
                            >
                                <div v-if="form.icon">
                                    <a-icon
                                            v-show="imgLoading"
                                            style="position: absolute; top: 45%; left: 45%"
                                            type="loading"
                                    />
                                    <img style="max-width: 180px;max-height: 180px" :src="form.icon | filterUrl" alt="avatar">
                                </div>
                                <div v-else>
                                    <a-icon :type="iconloading ? 'loading' : 'plus'"/>
                                </div>
                            </a-upload>
<!--                            <img :src="form.icon" style="width: 100%;height: 100%;object-fit: contain;" alt="">-->
                        </div>
                    </a-form-model-item>
                </a-col>
                <a-col :span="24">
                    <a-form-model-item label="视频文件" prop="uri" :labelCol="{span: 3}" :wrapperCol="{span: 20}">
                        <div v-if="!form.uri">
                            <a-button @click="pickResource"> <a-icon type="upload" /> 选择视频 </a-button>
                        </div>
                        <div v-else>
                            <div class="delete">
                                <a-icon type="paper-clip" /> {{form.fileName}}
                                <span class="close" style="color:#f00;margin-left:40px;" @click="deleteVideo">删除</span>
                            </div>
                        </div>
                    </a-form-model-item>
                </a-col>
                <a-col :span="24">
                    <a-form-model-item label="描述" :labelCol="{span: 3}" :wrapperCol="{span: 20}">
                        <a-input v-model="form.description" type="textarea"/>
                    </a-form-model-item>
                </a-col>
                <a-col :span="24">
                    <a-form-model-item label="备注" :labelCol="{span: 3}" :wrapperCol="{span: 20}">
                        <a-input v-model="form.remark" type="textarea"/>
                    </a-form-model-item>
                </a-col>

                <a-col :span="24" style="display: flex;justify-content: center;"
                       v-permission="`Content.CourseVideoSeting.Save`">
                    <a-button type="primary" @click="onSubmit" :disabled="subLoading">保存信息</a-button>
                </a-col>
            </a-row>
        </a-form-model>

        <!-- 选择资源 -->
        <a-modal title="添加视频" v-model="resource.visible"
                 @cancel="cancelResource"
                 @ok="addResource"
                 width="70%" destroyOnClose>
            <a-form-model layout="inline" :model="resource.search" @submit="resourceSearchSubmit" @submit.native.prevent>
                <a-form-model-item label="资源标题">
                    <a-input v-model="resource.search.name" allowClear placeholder="请输入" />
                </a-form-model-item>
                <a-form-model-item label="类型">
                    <a-select class="serach-item" v-model="resource.search.fileType" allowClear placeholder="请选择文件类型">
                        <a-select-option :value="item.value" :key="item.value" v-for="item in resource.searchFileType">
                            {{ item.name }}
                        </a-select-option>
                    </a-select>
                </a-form-model-item>
                <a-form-model-item>
                    <a-button type="primary" html-type="submit">
                        查询
                    </a-button>
                </a-form-model-item>
            </a-form-model>
            <ResourcesCenter ref="resourcesCenter" @nextFolder="searchCancel" checkType="radio"></ResourcesCenter>
        </a-modal>
    </div>
</template>

<script>
    import {FormatDate} from "@/pages/projectImpl/js/utils";
    import ResourcesCenter from "@/pages/content/courseSeting/components/ResourcesCenter.vue"

    function getBase64(img, callback) {
        const reader = new FileReader();
        reader.addEventListener("load", () => callback(reader.result));
        reader.readAsDataURL(img);
    }

    import moment from 'moment';
    import Apis from "@/requests/apis";

    export default {
        name: "baseSet",
        components: { ResourcesCenter },
        data() {
            return {
                moment,
                labelCol: {span: 9},
                wrapperCol: {span: 15},
                form: {
                    name: "",
                    versionName: undefined,
                    uri: undefined,
                    domainName: "",
                    description: "",
                    remark: "",
                    scientificName: undefined,
                    firstAbilityId: undefined,
                    firstAbilityName: "",
                    enabled: true,
                    contentType: 4,
                    icon: "",
                    endTime: undefined,
                    estimatedTime: 0,
                    minAge: undefined,
                    maxAge: undefined,
                    fileName:''//文件名称
                },
                dataEndTime: undefined,
                // icon
                iconloading: false,
                imgLoading: false,
                baseURL: process.env.VUE_APP_API_BASE_URL + Apis.File.upload + "?filePath=content/video",
                headers: {
                    Authorization: ""
                },
                modleRules: {
                    name: [{required: true, message: "请填写视频名称", trigger: "blur"}],
                    scientificName: [
                        {required: true, message: "请选择视频类型", trigger: "change"}
                    ],
                    firstAbilityId: [
                        {required: true, message: "请选择能力类型", trigger: "change"}
                    ],
                    icon: [{required: true, message: "请选择icon", trigger: "blur"}],
                    uri: [{required: true, message: "请选择视频文件", trigger: "blur"}],
                    minAge: [
                        {required: true, message: "请填写适用最小年龄", trigger: "blur"},
                        { min: 1, max: 150, message: '最小年龄 1 ~ 150', trigger: ['change', "blur"], type: "number" }
                    ],
                    maxAge: [
                        {required: true, message: "请填写适用最大年龄", trigger: "blur", type: "number" },
                        { min: 1, max: 150, message: '最大年龄 1 ~ 150', trigger: ['change', "blur"], type: "number" }
                    ],
                },
                firstAbility: [],
                subLoading: false,
                scientificName: [
                    {name: "大脑故事", icon: "https://cdn.iquizoo.com/content/game/video/大脑故事.png"},
                    {name: "大脑健身房", icon: "https://cdn.iquizoo.com/content/game/video/大脑健身房.png"},
                    {name: "大脑导航", icon: "https://cdn.iquizoo.com/content/game/video/大脑导航.png"},
                    {name: "游戏指导", icon: "https://cdn.iquizoo.com/content/game/video/大脑训练营.png"},
                    {name: "大脑加油站", icon: "https://cdn.iquizoo.com/content/game/video/大脑加油站.jpeg"},
                    {name: "大脑与生活", icon: "https://cdn.iquizoo.com/content/game/video/大脑与生活.png"},
                ],
                currentId: "",
                contentVersionId: "",
                agreement: "http",
                domainName: "",
                file: null,
                startUpload:false,
                videoName:'',
                timeout: '',
                partSize: '',
                parallel: '',
                retryCount: '',
                retryDuration: '',
                region: 'cn-shanghai',
                userId: '1111',
                authProgress: 0,
                uploadDisabled: true,
                resumeDisabled: true,
                pauseDisabled: true,
                uploader: null,
                statusText: '',
                resource:{
                    visible:false,
                    searchFileType: [{value: 0, name: "文件夹"}, {value: 4, name: "视频"}],
                    search:{
                        name: undefined,
                        fileType: undefined
                    }
                },
                settingIcon: false
            };
        },
        created() {
            let token = localStorage.getItem("token");
            this.headers.Authorization = "Bearer " + token;
            this.currentId = this.$route.query.id;
            if (this.$route.query.type == "edit") {
                this.getDetailByid();
            }
            this.getAbilitySelect();
        },
        watch:{
            "form.uri"(val){
                console.log(val)
                this.$refs.addForm.clearValidate('uri')
            },
        },
        computed:{
            age(){
                this.modleRules.maxAge[1].min = this.form.minAge;
                this.modleRules.maxAge[1].message = `最大年龄 ${this.form.minAge} ~ 150`;
                return this.form.minAge + "-" + this.form.maxAge
            }
        },
        methods: {
            searchCancel(){
                this.resource.search.name = undefined;
                this.resource.search.fileType = undefined;
            },
            // 选择资源
            pickResource(){
                this.resource.visible = true
            },
            addResource(){
                this.$refs.resourcesCenter.selectedRowKeys.forEach(v=>{
                    let record = JSON.parse(v)
                    this.form.uri = record.id
                    this.form.fileName = record.name
                    this.form.estimatedTime = record.estimatedTime
                })
                this.resource.visible = false
            },
            // 删除视频文件
            deleteVideo(){
                let that = this
                that.$confirm({
                    title: '确定删除',
                    content: '确定删除该视频资源？',
                    okText: '删除',
                    okType: 'danger',
                    cancelText: '取消',
                    onOk() {
                        that.form.uri = '';
                    },
                    onCancel() {
                        console.log('Cancel');
                    },
                });
            },

            selectChange(val){
                if (!this.settingIcon) {
                    if (!val){
                        this.form.icon = "";
                        return
                    }
                    this.form.icon = this.scientificName.filter(f => f.name === val)[0].icon;
                }
            },

            //获取五大能力
            getAbilitySelect() {
                let params = {
                    isSelect: true,
                    abilityType: 0,
                };
                this.$http.courseAbilitySelect(params).then(res => {
                        this.firstAbility = res.data.data;
                });
            },
            // 根据id获取基本信息
            getDetailByid() {
                let params = {
                    id: this.currentId
                };
                this.$http.getVideoDetail(params).then(res => {
                        let dataItem = res.data.data;
                        for (let key in dataItem) {
                            for (let k in this.form) {
                                if (key == k) {
                                    this.form[key] = dataItem[key];
                                }
                            }
                        }
                        this.contentVersionId = dataItem.contentVersionId;
                        this.form.name = dataItem.name;
                        // 处理老数据，没有为undefined
                        if (this.form.firstAbilityId == this.form.firstAbilityName) {
                            this.form.firstAbilityId = undefined;
                            this.form.firstAbilityName = "";
                        }
                        this.agreement = dataItem.uri.split("://")[0];
                        this.domainName = dataItem.uri.split("://")[1];
                        if (dataItem.endTime == "NaN:NaN:NaN" || dataItem.endTime == "") {
                            this.form.endTime = undefined;
                        } else {
                            this.form.endTime = dataItem.endTime;
                            this.dataEndTime = moment(this.form.endTime, "HH:mm:ss");
                        }
                        if (!this.scientificName.filter(f => f.name === this.form.scientificName).length) {
                            this.form.scientificName = undefined;
                            this.form.icon = '';
                            this.settingIcon = false;
                        } else {
                            this.settingIcon = !!this.form.icon;
                            this.selectChange(this.form.scientificName);
                        }
                        if (!this.form.contentType){
                            this.form.contentType = 4;
                        }

                });
            },
            // 判断是否能够修改状态
            StatusChange() {
                if (this.$route.query.type == "edit") {
                    const fn = () => {
                        let formData = new FormData();
                        formData.append("id", this.currentId);
                        formData.append("enabled", this.form.enabled);
                        this.$http.contentCheckStatus(formData).then(res => {
                                this.form.enabled = !this.form.enabled;

                        });
                    };
                    if (this.form.enabled) {
                        this.form.enabled = true;
                        this.$confirm({
                            title: `确认禁用【${this.form.name}】`,
                            content: "视频禁用后，已配置的课程将移除该视频且不可恢复，请谨慎操作",
                            centered: true,
                            onOk: fn
                        });
                        return
                    }
                    fn();
                } else {
                    this.form.enabled = !this.form.enabled;
                }
            },
            firstAbilityChange(value, option) {
                this.form.firstAbilityName = option[0];
            },
            changeTime(value) {
                let time = value._d;
                this.form.endTime = time + "";
                this.$refs.addForm.validateField("endTime");
            },
            changeIcon(info) {
                if (info.fileList[0].response) {
                    this.form.icon = info.fileList[0].response.data;
                }
                if (info.file.status === "uploading") {
                    this.iconloading = true;
                    this.imgLoading = true;
                    return;
                }
                if (info.file.status === "done") {
                    getBase64(info.file.originFileObj, imageUrl => {
                        this.form.icon = info.file.response.data;
                        this.iconloading = false;
                        this.imgLoading = false;
                        this.$refs.addForm.validateField("icon");
                    });
                }
            },
            beforeIcon(file) {
                const isJpgOrPng =
                    file.type === "image/jpeg" || file.type === "image/png";
                if (!isJpgOrPng) {
                    this.$message.error("请上传jpg或者png图片!");
                }
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isLt2M) {
                    this.$message.error("图片大小不能超过2M!");
                }
                return isJpgOrPng && isLt2M;
            },
            onSubmit() {
                if (!this.dataEndTime) {
                    this.form.endTime = "";
                }
                if (this.form.endTime.indexOf("中国标准时间") > 0) {
                    this.form.endTime = FormatDate(this.form.endTime, "hh:mm:ss");
                }
                this.$refs.addForm.validate(valid => {
                    if (valid) {
                        if (this.$route.query.type == "add") {
                            this.addEGamege();
                        } else {
                            this.editEGamege();
                        }
                    } else {
                    }
                });
            },
            addEGamege() {
                this.form.contentId = this.currentId;
                this.form.contentVersionId = 0;
                if (this.file && this.file.name){
                    this.form.fileName = this.file.name;
                }
                this.$http.addContentVideo(this.form).then(res => {
                    this.subLoading = false;
                        this.form = {
                            name: "",
                            uri: "",
                            description: "",
                            remark: "",
                            scientificName: undefined,
                            firstAbilityId: undefined,
                            firstAbilityName: "",
                            enabled: true,
                            ContentType: 4,
                            icon: "",
                            endTime: ""
                        };
                        this.$message.destroy();
                        this.$message.success("添加成功");
                        this.$router.push("/content/CourseVideo");

                });
            },
            editEGamege(type) {
                console.log(this.form.endTime)
                this.form.id = this.currentId;
                this.form.contentVersionId = this.contentVersionId;
                this.$http.updataContentVideo(this.form).then(res => {
                        this.$message.destroy();

                        this.getDetailByid();
                        if(type != 'delete'){
                            this.$message.success("修改成功");
                            this.$router.push("/content/CourseVideo");
                        }else{
                            this.$message.success('删除成功');
                        }

                    this.subLoading = false;
                });
            },

            resourceSearchSubmit(){
                this.$refs.resourcesCenter.$data.search.name = this.resource.search.name;
                this.$refs.resourcesCenter.$data.search.fileType = this.resource.search.fileType;
                this.$refs.resourcesCenter.$data.search.isAll = !!this.resource.search.name;
                if (this.resource.search.name){
                    this.$store.commit("file/setPaths", []);
                    this.$refs.resourcesCenter.$data.search.id = undefined;
                }
                this.$refs.resourcesCenter.getPageList(1);
            },
            cancelResource(){
                this.resource.visible = false;
                for (const searchKey in this.resource.search) {
                    this.resource.search[searchKey] = undefined;
                }
            }
        }
    };
</script>

<style scoped lang="less">
    .baseSet {
        width: 100%;
        h1 {
            font-size: 20px;
            font-weight: 600;
            color: rgba(0, 0, 0, 0.85);
        }
        .ant-form-item {
            margin-bottom: 20px;
        }
        .baseForm {
            position: relative;
            // width: 50%;
            margin: 0 auto;
            label {
                font-size: 16px;
                display: inline-block;
            }
            label::before {
                margin-right: 4px;
                color: #f5222d;
                font-size: 14px;
                font-family: SimSun, sans-serif;
                line-height: 1;
                content: "*";
            }
        }
    }

    /deep/ .avatar-uploader {
        width: 200px;
        height: 200px;
    }

    /deep/ .ant-upload.ant-upload-select-picture-card {
        width: 200px;
        height: 200px;
    }

    .age /deep/ label:before {
        display: inline-block;
        margin-right: 4px;
        color: #f5222d;
        font-size: 14px;
        font-family: SimSun, sans-serif;
        line-height: 1;
        content: '*';
    }

    .age /deep/.ant-form-item{
        height: 59px;
        margin-bottom: 0;
    }

    .age-cont {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    /deep/ .ant-upload-list{
        display:none;
    }
    .progress{
        width:50%;
        position: relative;
        display: flex;
        flex-direction: column;
    }
    .close{
        cursor: pointer;
    }
    .icon{
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 95%;
        height:20px;
    }
    .delete{
        display: flex;
        align-items: center;
        width: 50%;
    }
</style>
